import { useEffect, useState, useRef } from "react";
import SuccessModal from "../SuccessModal";
import ProgressBar from "../../pages/ProgressBar";
import BankDetailsStep from "../../pages/BankDetailsStep";
import BasicDetailsStep from "../../pages/BasicDetailsStep";
import BusinessDetailsStep from "../../pages/BusinessDetailsStep";
import KYCVerificationStep from "../../pages/KYCVerificationStep";
import { config } from "../../utils/config";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { toast, ToastContainer } from "react-toastify";
// import {createAnalyticsPayload} from "../../utils/analytics";
import { BsSkipForwardFill } from "react-icons/bs";
import { useHistory } from "react-router-dom";
// import Sidebar from "../../components/thememaker/sidebar";
// import ThemeMaker from "../../components/ThemeMaker/";
import ThemeMaker from "../../components/thememaker";

// import Toaster from "../../components/Toaster/Toaster";
const TOTAL_STEPS = 4;




// 🚨 MOCK API TOGGLE FOR TESTING (Set to false when you want to use real paid APIs)
// const IS_MOCK_TESTING = false;

export default function Sellerdetails_kyc() {
    const { apiEndpoint } = config;
    const history = useHistory();
    const isSubmittingRef = useRef(false);
    const [currentStep, setCurrentStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [showPanField, setShowPanfield] = useState(false);
    const [isGSTVerified, setIsGSTVerified] = useState(false);
    const [isPanVerified, setIsPANVerified] = useState(false);
    const [isAadharVerified, setIsAadharVerified] = useState(false);
    const [prefillBasicData, setPrefillBasicData] = useState({});
    const [prefillBankData, setPrefillBankData] = useState({});
    const [isBankVerified, setIsBankVerified] = useState(false);
    const [bankSuccess, setBankSuccess] = useState(false);
    const [bankData, setBankData] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [modalConfig, setModalConfig] = useState({ show: false, type: "success", message: "" });
    const [isBankValid, setIsBankValid] = useState(false);

    // const [formData, setFormData] = useState(() => {
    //     const saved = sessionStorage.getItem("seller_kyc_draft") || localStorage.getItem("seller_kyc_draft");
    //     if (saved) {
    //         try {
    //             return JSON.parse(saved);
    //         } catch (e) {
    //             console.error("Failed to parse kyc draft:", e);
    //         }
    //     }
    //     return {
    //         business: {},
    //         basic: {},
    //         bank: {},
    //         kyc: {}
    //     };
    // });


    const [formData, setFormData] = useState({
        business: {},
        basic: {},
        bank: {},
        kyc: {}
    });
    // useEffect(() => {
    //     if (formData && (Object.keys(formData.business || {}).length > 0 || Object.keys(formData.basic || {}).length > 0 || Object.keys(formData.bank || {}).length > 0)) {
    //         sessionStorage.setItem("seller_kyc_draft", JSON.stringify(formData));
    //         localStorage.setItem("seller_kyc_draft", JSON.stringify(formData));
    //     }
    // }, [formData]);


    const verifyGST = async (gst_no) => {
        // if (IS_MOCK_TESTING) {
        //     console.log("⚡ BYPASSING PAID GST API: Mock response returned");
        //     return {
        //         status: true,
        //         message: "GST verified successfully (MOCK)",
        //         data: {
        //             status: true,
        //             data: {
        //                 business_name: "TEST COMPANY PRIVATE LIMITED",
        //                 business_pan: "AAACB0098G",
        //                 business_entity_type: "Private Limited Company",
        //                 gst_number: gst_no || "07AAACB0098G1ZT",
        //                 business_address: "UTTAR PRADESH, 221003",
        //                 pincode: "221003",
        //                 city: "VARANASI",
        //                 state: "UTTAR PRADESH"
        //             }
        //         }
        //     };
        // }
        try {
            const token = sessionStorage.getItem("token");
            const response = await fetch(`${apiEndpoint}/snp/verify/gst`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify({ gst_no }),
            });
            const data = await response.json();

            // console.log("data from gst api ", data)
            if (!response.ok || data.status === false || data.success === false) {
                if (data.message == "Validation error") {
                    return toast.error("Company Already Registered ")
                }
                throw new Error(data.message || "GST verification is unsuccessful!");
            }
            console.log("345678987654567", data)
            return data;
        } catch (error) {
            console.log("GST Verify Error:", error.message);
            throw error;
        }
    };







    // consolo.log("verifygst is getting data ",verifyGST)
    const verifyPanDetails = async (pan_name) => {
        // console.log(pan_name);
        // if (IS_MOCK_TESTING) {
        //     console.log("⚡ BYPASSING PAID AADHAAR API: Mock response returned");
        //     return {
        //         status: true,
        //         message: "Aadhaar verified successfully (MOCK)",
        //         digi_locker_url: null,
        //         response: {
        //             data: {
        //                 aadhar_no: pan_name,
        //                 name: "Test User"
        //             }
        //         }
        //     };
        // }

        try {
            const token = sessionStorage.getItem("token");
            const res = await fetch(`${apiEndpoint}/snp/verify/aadhar`, {
                method: "POST",

                headers: {
                    "Content-Type": "application/json",
                    "X-Custom-Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify({
                    aadhar_no: pan_name,
                }),
            });


            return await res.json();

        } catch (err) {
            alert()
            return "Server Error"
        }
    };

    const apiKey = `sV2DUZ52gtPE82AAmbhljWm19H2jJVBnCQvXglZo`;

    const fetchGeocodeApi = async (queryStr) => {
        if (!queryStr || !queryStr.trim()) return null;
        try {
            const res = await fetch(
                `https://api.olamaps.io/places/v1/geocode?address=${encodeURIComponent(queryStr.trim())}&api_key=${apiKey}`
            );
            const data = await res.json();
            if (data?.status === "ok" && data?.geocodingResults?.length > 0) {
                const location = data.geocodingResults[0]?.geometry?.location;
                if (location?.lat != null && location?.lng != null) {
                    return location;
                }
            }
            return null;
        } catch (err) {
            console.log("Geocode fetch error for:", queryStr, err);
            return null;
        }
    };

    const getLatLng = async (address, fallbackAddress = "") => {
        try {
            // 1. Try full address query without language=hi & without dummy X-Request-Id header
            let location = await fetchGeocodeApi(address);

            // 2. If full address timed out or returned empty, retry with fallback address
            if (!location && fallbackAddress && fallbackAddress !== address) {
                console.log("Full address geocode failed/timed out, trying fallback query:", fallbackAddress);
                location = await fetchGeocodeApi(fallbackAddress);
            }

            return {
                latitude: location?.lat != null ? String(location.lat) : "",
                longitude: location?.lng != null ? String(location.lng) : ""
            };
        } catch (err) {
            console.log("Geocode Error:", err);
            return { latitude: "", longitude: "" };
        }
    };

    const handleNext = async () => {
        if (isSubmittingRef.current || loading) return;
        isSubmittingRef.current = true;
        setLoading(true);

        try {
            if (currentStep === 2) {
                if (!isAadharVerified) {
                    const aadhaarNo = formData?.basic?.pan_number;
                    if (!aadhaarNo || String(aadhaarNo).trim().length < 10) {
                        toast.error("Please enter a valid Aadhaar number", {
                            style: {
                                background: "#fde9e9",
                                borderRadius: "10px",
                                padding: "14px",
                                fontSize: "15px",
                                border: "1px solid red"
                            },
                            hideProgressBar: true,
                        });
                        return;
                    }

                    // Automatically trigger Aadhaar DigiLocker verification if user clicked Next
                    const res = await verifyPanDetails(aadhaarNo);
                    console.log("Aadhaar response on handleNext:", res);
                    const meonUrl = res?.digi_locker_url?.url || (typeof res?.digi_locker_url === "string" ? res?.digi_locker_url : null) || res?.url || res?.redirect_url || res?.data?.url || res?.response?.data?.digi_locker_url?.url || res?.response?.data?.digi_locker_url;

                    if (meonUrl) {
                        window.location.replace(meonUrl);
                        return;
                    }

                    if (res?.status || res?.response?.data) {
                        setIsAadharVerified(true);
                        setCurrentStep((prev) => prev + 1);
                        return;
                    } else {
                        toast.error(res?.message || res?.error || "Aadhaar verification failed", {
                            style: {
                                background: "#fde9e9",
                                borderRadius: "10px",
                                padding: "14px",
                                fontSize: "15px",
                                border: "1px solid red"
                            },
                            hideProgressBar: true,
                        });
                        return;
                    }
                }
                setCurrentStep((prev) => prev + 1);
                return;
            }
            if (currentStep === TOTAL_STEPS) {
                const isSuccess = await activeSellerHandler();
                if (isSuccess) {
                    setShowSuccess(true);
                }
                return;
            }
            let payload = {};
            let url = "";
            const token = sessionStorage.getItem("token");
            if (currentStep === 1) {
                const b = formData.business;
                console.log("business data---->", b);
                const isGST = b.tax_type === "gst";
                if (b.street === "" || b.locality === "") {
                    toast.error("Please enter all fields", {
                        style: {
                            background: "#fde9e9",
                            borderRadius: "10px",
                            padding: "14px",
                            fontSize: "15px",
                            border: "1px solid red"
                        },
                        hideProgressBar: true,
                    });
                    return;
                }

                const fullAddress = [b.street, b.locality, b.city, b.state, b.pincode || b.area_code, b.country || "India"].filter(Boolean).join(", ");
                const fallbackAddress = [b.locality, b.city, b.pincode || b.area_code, "India"].filter(Boolean).join(", ") || b.pincode || b.area_code || "";
                const pincodeOnly = b.pincode || b.area_code || "";
                const city = b.city || b.city_name || b.district || b.city_code || "";

                let { latitude, longitude } = await getLatLng(fullAddress, fallbackAddress);
                if (!latitude || !longitude) {
                    const fallbackPincode = await getLatLng(pincodeOnly);
                    latitude = fallbackPincode.latitude;
                    longitude = fallbackPincode.longitude;
                }

                payload = {
                    "verification_type": "gst",
                    bussiness_type: b.bussiness_type || b.business_entity_type || "",
                    company_name: b.company_name || b.business_name || "",
                    seller_type: b.seller_type || "",
                    street: b.street || "",
                    city: city,
                    area_code: b.pincode || b.area_code || "",
                    state: b.state || "",
                    country: b.country || "India",
                    locality: b.locality || "",
                    pan_name: b.pan_name || b.company_name || b.business_name || "",
                    gst_no: b.gst_number || b.gst_no || "",
                    pan_no: b.pan_number || b.pan_no || b.business_pan || "",
                    latitude: latitude || "",
                    longitude: longitude || ""
                };
                url = `${apiEndpoint}/snp/verify/insert-business-details`;
            }

            if (currentStep === 3) {
                const bank = formData?.bank || {};
                const name = (bank.name || "").toString().trim();
                const ifsc = (bank.ifsc || "").toString().trim();
                const accountnumber = (bank.accountnumber || bank.account_number || "").toString().trim();
                const accounttype = (bank.accounttype || "").toString().trim();

                if (!name) {
                    toast.error("Please enter Account Holder Name", {
                        style: {
                            background: "#fde9e9",
                            borderRadius: "10px",
                            padding: "14px",
                            fontSize: "15px",
                            border: "1px solid red"
                        },
                        hideProgressBar: true,
                    });
                    return;
                }

                if (!ifsc) {
                    toast.error("Please enter IFSC Code", {
                        style: {
                            background: "#fde9e9",
                            borderRadius: "10px",
                            padding: "14px",
                            fontSize: "15px",
                            border: "1px solid red"
                        },
                        hideProgressBar: true,
                    });
                    return;
                }

                if (!accountnumber) {
                    toast.error("Please enter Account Number", {
                        style: {
                            background: "#fde9e9",
                            borderRadius: "10px",
                            padding: "14px",
                            fontSize: "15px",
                            border: "1px solid red"
                        },
                        hideProgressBar: true,
                    });
                    return;
                }

                if (!accounttype) {
                    toast.error("Please select Account Type", {
                        style: {
                            background: "#fde9e9",
                            borderRadius: "10px",
                            padding: "14px",
                            fontSize: "15px",
                            border: "1px solid red"
                        },
                        hideProgressBar: true,
                    });
                    return;
                }

                const mobile = sessionStorage.getItem("mobile");
                payload = {
                    name,
                    ifsc,
                    accountnumber,
                    accounttype,
                    mobile
                };
                delete payload.bankname;
                delete payload.branchname;
                delete payload.bank_name;
                delete payload.branch_name;
                url = `${apiEndpoint}/snp/verify/bank`;
            }

            const res = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify(payload)
            });
            const data = await res.json();
            const msg = (data?.message || data?.error || "").toString().toLowerCase();
            const isAlreadyVerified = msg.includes("already verified") || msg.includes("already exist") || Boolean(data?.response?.account_no || data?.response?.accountnumber);

            if ((!res.ok || data?.status === false || data?.success === false) && !isAlreadyVerified) {
                console.log("API Error", data);
                toast.error(data?.message || data?.error || "Verification failed", {
                    style: {
                        background: "#fde9e9",
                        borderRadius: "10px",
                        padding: "14px",
                        fontSize: "15px",
                        border: "1px solid red"
                    },
                    hideProgressBar: true,
                });
                return;
            }

            if (currentStep === 3) {
                setIsBankVerified(true);
                sessionStorage.setItem("bankVerified", "true");
                setCurrentStep((prev) => prev + 1);
                return;
            }

            if (currentStep < TOTAL_STEPS) {
                setCurrentStep((prev) => prev + 1);
            } else {
                setShowSuccess(true);
            }

        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
            isSubmittingRef.current = false;
        }
    };

    useEffect(() => {
        const isVerified = sessionStorage.getItem("bankVerified");
        const hasBankData = Boolean(formData?.bank?.accountnumber || formData?.bank?.account_number);
        if (isVerified === "true" && hasBankData) {
            setIsBankVerified(true);
            setBankSuccess(true);
        } else if (!hasBankData) {
            setIsBankVerified(false);
            setBankSuccess(false);
        }
    }, [formData?.bank]);

    //  useEffect(() => {
    //     const handleDigiLockerCallback = async () => {
    //         const urlParams = new URLSearchParams(window.location.search);
    //         const code = urlParams.get("code");
    //         const state = urlParams.get("state");
    //         if (!code || !state) return;
    //         try {
    //             setLoading(true);
    //             const token = sessionStorage.getItem("token");
    //             const res = await fetch(`${apiEndpoint}/snp/verify/digilocker-callback`, {
    //                 method: "POST",
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     "X-Custom-Authorization": `Bearer ${token}`,
    //                 },
    //                 body: JSON.stringify({ code, state }),
    //             });
    //             const data = await res.json();
    //             if (res.ok && data?.status) {
    //                 const savedAadhar = sessionStorage.getItem("pendingAadhar") || "";
    //                 setFormData((prev) => ({
    //                     ...prev,
    //                     basic: {
    //                         ...prev.basic,
    //                         aadhar_number: savedAadhar,
    //                         aadhar_verified: true,
    //                     }
    //                 }));
    //                 setIsPANVerified(true);
    //                 setCurrentStep(2);
    //                 sessionStorage.removeItem("pendingAadhar");
    //                 toast.success("Aadhaar verified successfully! ✅", {
    //                     style: {
    //                         background: "#e8f5e9",
    //                         borderRadius: "10px",
    //                         padding: "14px",
    //                         fontSize: "15px",
    //                         border: "1px solid green"
    //                     },
    //                     hideProgressBar: true,
    //                 });
    //             } else {
    //                 toast.error(data?.message || "Aadhaar verification failed.", {
    //                     style: {
    //                         background: "#fde9e9",
    //                         borderRadius: "10px",
    //                         padding: "14px",
    //                         fontSize: "15px",
    //                         border: "1px solid red"
    //                     },
    //                     hideProgressBar: true,
    //                 });
    //             }
    //         } catch (err) {
    //             console.error("DigiLocker callback error:", err);
    //         } finally {
    //             setLoading(false);
    //             window.history.replaceState({}, document.title, window.location.pathname);
    //         }
    //     };
    //     handleDigiLockerCallback();
    // }, []);


    useEffect(() => {
        const handleDigiLockerCallback = async () => {

            const urlParams = new URLSearchParams(window.location.search);
            const seller_id = urlParams.get("seller_id");
            const client_token = urlParams.get("client_token");
            const state = urlParams.get("state");
            console.log("ertyuio", urlParams);
            console.log("seller_id", seller_id)
            console.log("client_token", client_token)
            console.log("state", state)




            if (!seller_id || !client_token || !state) return;
            setCurrentStep(2);

            try {
                setLoading(true);
                const token = sessionStorage.getItem("token");

                const res = await fetch(`${apiEndpoint}/snp/verify/aadhar-details`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Custom-Authorization": `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        seller_id: Number(seller_id),
                        client_token,
                        state
                    }),
                });
                console.log("res---->", res)
                console.log("res---->", res.data)
                const data = await res.json();

                if (res.ok && data?.status) {
                    setFormData((prev) => ({
                        ...prev,
                        basic: {
                            ...prev.basic,
                            pan_number: data?.response?.data?.aadhar_no || "",
                            aadhar_verified: true,
                        }
                    }));

                    setIsAadharVerified(true);
                    setIsPANVerified(true);
                    setCurrentStep(2);

                    toast.success("Aadhaar verified successfully! ✅", {
                        style: {
                            background: "#e8f5e9",
                            borderRadius: "10px",
                            padding: "14px",
                            fontSize: "15px",
                            border: "1px solid green"
                        },
                        hideProgressBar: true,
                    });

                } else {
                    toast.error(data?.message || "Aadhaar verification failed.", {
                        style: {
                            background: "#fde9e9",
                            borderRadius: "10px",
                            padding: "14px",
                            fontSize: "15px",
                            border: "1px solid red"
                        },
                        hideProgressBar: true,
                    });
                }

            } catch (err) {
                console.error("DigiLocker callback error:", err);
            } finally {
                setLoading(false);
                window.history.replaceState(
                    {},
                    document.title,
                    window.location.pathname
                );
            }
        };

        handleDigiLockerCallback();
    }, []);


    // Auto fetch Aadhaar details from POST /snp/verify/get-aadhar-details when on Step 2
    useEffect(() => {
        if (currentStep === 2 && !isAadharVerified) {
            const fetchAadharFromBackend = async () => {
                try {
                    const token = sessionStorage.getItem("token");
                    if (!token) return;
                    let decoded = {};
                    try { decoded = jwt_decode(token); } catch (e) { }
                    const userObj = Array.isArray(decoded?.data?.user) ? decoded?.data?.user[0] : (decoded?.data?.user || {});
                    const sellerObj = Array.isArray(decoded?.data?.seller_data) ? decoded?.data?.seller_data[0] : (decoded?.data?.seller_data || {});

                    const res = await axios.post(
                        `${apiEndpoint}/snp/verify/get-aadhar-details`,
                        {
                            seller_id: sellerObj?.id || userObj?.seller_id
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                "Authorization": `Bearer ${token}`,
                                "X-Custom-Authorization": `Bearer ${token}`,
                            }
                        }
                    );
                    const resData = res?.data;
                    const aadharData = resData?.data || resData?.response?.data || resData;
                    const aadharNo = aadharData?.aadhar_no
                        || aadharData?.aadhar_number
                        || aadharData?.pan_number
                        || resData?.aadhar_no
                        || aadharData?.kyc?.aadhar_no
                        || aadharData?.non_verify_aadhar;

                    const isSuccess = Boolean(resData?.status === true || resData?.status === 200 || resData?.success === true);

                    if (isSuccess && aadharNo) {
                        setFormData((prev) => ({
                            ...prev,
                            basic: {
                                ...(prev?.basic || {}),
                                pan_number: aadharNo,
                                aadhar_verified: true,
                            }
                        }));
                        setIsAadharVerified(true);
                        setIsPANVerified(true);
                    }
                } catch (err) {
                    console.log("get-aadhar-details fetch error:", err?.response?.data || err?.message);
                }
            };
            fetchAadharFromBackend();
        }
    }, [currentStep, isAadharVerified]);

    const getAllbusinessInfo = async () => {
        try {
            const token = sessionStorage.getItem("token");
            var decoded = jwt_decode(token);
            const sellerObj = Array.isArray(decoded?.data?.seller_data) ? decoded?.data?.seller_data[0] : (decoded?.data?.seller_data || {});
            const res = await axios({
                url: `${apiEndpoint}/snp/verify/step-one`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                    "X-Custom-Authorization": `Bearer ${token}`
                },
                data: {
                    gst_no: formData?.business?.gst_number || sellerObj?.gst_no || sellerObj?.gst_number || "",
                    seller_id: sellerObj?.id || ""
                }
            });

            const resPayload = res?.data;
            const apiData = resPayload?.data;

            // Check if data is present and contains details
            const isDataPresent = Boolean(
                apiData &&
                typeof apiData === "object" &&
                Object.keys(apiData).length > 0 &&
                (apiData?.gst_no || apiData?.gst_kyc || apiData?.pan_no || apiData?.business_type || apiData?.city || apiData?.state)
            );

            if (isDataPresent) {
                // Condition 1: Data is present -> Show all details provided by response
                const companyName = apiData?.company_name || apiData?.business_name || apiData?.pan_name || sellerObj?.company_name || "";
                const bussinessType = apiData?.bussiness_type || apiData?.business_type || sellerObj?.seller_type || "";
                const pincodeVal = apiData?.pincode || apiData?.area_code || "";
                const panNo = apiData?.pan_no || apiData?.pan_number || "";
                const gstNo = apiData?.gst_no || apiData?.gst_number || sellerObj?.gst_no || "";

                setFormData((prev) => ({
                    ...prev,
                    business: {
                        ...prev.business,
                        gst_number: gstNo || prev.business.gst_number,
                        company_name: companyName || prev.business.company_name,
                        bussiness_type: bussinessType || prev.business.bussiness_type,
                        seller_type: apiData?.seller_type ? String(apiData.seller_type).toLowerCase() : (sellerObj?.seller_type ? String(sellerObj.seller_type).toLowerCase() : (prev.business.seller_type || "")),
                        pan_number: panNo || prev.business.pan_number,
                        pan_name: apiData?.pan_name || companyName || prev.business.pan_name,
                        street: apiData?.street || prev.business.street,
                        city: apiData?.city || prev.business.city,
                        pincode: pincodeVal || prev.business.pincode,
                        state: apiData?.state || prev.business.state,
                        locality: apiData?.locality || prev.business.locality,
                        city_code: apiData?.city_code || prev.business.city_code || "",
                        country: "India"
                    }
                }));
                setPrefillBasicData(apiData);
                setShowPanfield(true);
                setIsGSTVerified(true);
            } else if (sellerObj?.company_name && String(sellerObj?.company_name).trim() !== "") {
                setFormData((prev) => ({
                    ...prev,
                    business: {
                        ...prev.business,
                        company_name: sellerObj.company_name,
                        seller_type: sellerObj.seller_type ? String(sellerObj.seller_type).toLowerCase() : (prev.business.seller_type || ""),
                        gst_number: sellerObj?.gst_no || prev.business.gst_number || "",
                        country: "India"
                    }
                }));
                setShowPanfield(true);
                setIsGSTVerified(true);
            } else {
                // Condition 2: Data is not present -> Show GST Number input field
                setShowPanfield(false);
                setIsGSTVerified(false);
            }
            return resPayload;
        } catch (error) {
            console.log("Error ------>", error);
            try {
                const token = sessionStorage.getItem("token");
                const decoded: any = jwt_decode(token);
                const sellerObj = Array.isArray(decoded?.data?.seller_data) ? decoded?.data?.seller_data[0] : (decoded?.data?.seller_data || {});
                if (sellerObj?.company_name && String(sellerObj?.company_name).trim() !== "") {
                    setFormData((prev) => ({
                        ...prev,
                        business: {
                            ...prev.business,
                            company_name: sellerObj.company_name,
                            seller_type: sellerObj.seller_type ? String(sellerObj.seller_type).toLowerCase() : (prev.business.seller_type || ""),
                            country: "India"
                        }
                    }));
                    setShowPanfield(true);
                    setIsGSTVerified(true);
                } else {
                    setShowPanfield(false);
                    setIsGSTVerified(false);
                }
            } catch (e) {
                setShowPanfield(false);
                setIsGSTVerified(false);
            }
            return null;
        }
    };

    const getBankDetails = async () => {
        try {
            const token = sessionStorage.getItem("token");
            const res = await axios({
                url: `${apiEndpoint}/snp/verify/get-bank-details`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                    "X-Custom-Authorization": `Bearer ${token}`
                }
            });
            return res.data;
        } catch (error) {
            console.log("Bank Details Error:", error);
            return null;
        }
    };

    useEffect(() => {
        const checkKYCProgressAndSetStep = async () => {
            setLoading(true);
            try {
                const token = sessionStorage.getItem("token");
                if (!token) {
                    setLoading(false);
                    return;
                }

                let decoded = {};
                try {
                    decoded = jwt_decode(token);
                } catch (e) {
                    console.log("KYC token decode error:", e);
                }
                const userObj = Array.isArray(decoded?.data?.user) ? decoded?.data?.user[0] : (decoded?.data?.user || {});
                const sellerObj = Array.isArray(decoded?.data?.seller_data) ? decoded?.data?.seller_data[0] : (decoded?.data?.seller_data || {});

                // 1. Check Step 1 (GST / Business Details)
                const step1Res = await getAllbusinessInfo();
                const isStep1Done = Boolean(step1Res?.status === true);

                if (!isStep1Done) {
                    setCurrentStep(1);
                    setLoading(false);
                    return;
                }

                if (step1Res?.data) {
                    const apiData = step1Res.data;
                    const companyName = apiData?.company_name || apiData?.business_name || apiData?.pan_name || sellerObj?.company_name || "";
                    const bussinessType = apiData?.bussiness_type || apiData?.business_type || sellerObj?.seller_type || "";
                    const pincodeVal = apiData?.pincode || apiData?.area_code || "";
                    const panNo = apiData?.pan_no || apiData?.pan_number || "";
                    const gstNo = apiData?.gst_no || apiData?.gst_number || sellerObj?.gst_no || "";

                    setFormData((prev) => ({
                        ...prev,
                        business: {
                            ...prev.business,
                            gst_number: gstNo || prev.business.gst_number,
                            company_name: companyName || prev.business.company_name,
                            bussiness_type: bussinessType || prev.business.bussiness_type,
                            seller_type: apiData?.seller_type ? String(apiData.seller_type).toLowerCase() : (sellerObj?.seller_type ? String(sellerObj.seller_type).toLowerCase() : (prev.business.seller_type || "")),
                            pan_number: panNo || prev.business.pan_number,
                            pan_name: apiData?.pan_name || companyName || prev.business.pan_name,
                            street: apiData?.street || prev.business.street,
                            city: apiData?.city || prev.business.city,
                            pincode: pincodeVal || prev.business.pincode,
                            state: apiData?.state || prev.business.state,
                            locality: apiData?.locality || prev.business.locality,
                            country: "India"
                        }
                    }));
                    setPrefillBasicData(apiData);
                    setShowPanfield(true);
                    setIsGSTVerified(true);
                } else if (sellerObj?.company_name) {
                    setFormData((prev) => ({
                        ...prev,
                        business: {
                            ...prev.business,
                            company_name: sellerObj.company_name,
                            seller_type: sellerObj.seller_type ? String(sellerObj.seller_type).toLowerCase() : (prev.business.seller_type || ""),
                            country: "India"
                        }
                    }));
                    setShowPanfield(true);
                    setIsGSTVerified(true);
                }

                // 2. Check Step 2 (Aadhaar Details)
                let step2Success = false;
                try {
                    const aadharRes = await axios.post(
                        `${apiEndpoint}/snp/verify/get-aadhar-details`,
                        {
                            seller_id: sellerObj?.id || userObj?.seller_id
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                "Authorization": `Bearer ${token}`,
                                "X-Custom-Authorization": `Bearer ${token}`,
                            }
                        }
                    );
                    const resData = aadharRes?.data;
                    const aadharData = resData?.data || resData?.response?.data || resData;
                    const aadharNo = aadharData?.aadhar_no
                        || aadharData?.aadhar_number
                        || aadharData?.pan_number
                        || resData?.aadhar_no
                        || aadharData?.kyc?.aadhar_no
                        || aadharData?.non_verify_aadhar;

                    const isAadharValid = Boolean(
                        (resData?.status === true || resData?.status === 200 || resData?.success === true) &&
                        aadharNo &&
                        String(aadharNo).trim() !== ""
                    );

                    if (isAadharValid) {
                        step2Success = true;
                        setFormData((prev) => ({
                            ...prev,
                            basic: {
                                ...(prev?.basic || {}),
                                pan_number: aadharNo,
                                aadhar_verified: true,
                            }
                        }));
                        setIsAadharVerified(true);
                        setIsPANVerified(true);
                    }
                } catch (e) {
                    console.log("Step 2 check error:", e);
                }

                if (!step2Success) {
                    setCurrentStep(2);
                    setLoading(false);
                    return;
                }

                // 3. Check Step 3 (Bank Details)
                let step3Success = false;
                try {
                    const bankRes = await getBankDetails();
                    const bankApiData = Array.isArray(bankRes?.data) ? bankRes?.data[0] : (bankRes?.data || bankRes?.response?.data);
                    const bankAccNum = bankApiData?.accountnumber || bankApiData?.bankaccount || bankApiData?.account_number || bankApiData?.bank_account || bankApiData?.account_no || "";
                    const hasBankDetails = Boolean(
                        (bankRes?.status === true || bankRes?.status === 200 || bankRes?.success === true) &&
                        bankAccNum &&
                        String(bankAccNum).trim() !== ""
                    );

                    if (hasBankDetails) {
                        step3Success = true;
                        setFormData((prev) => ({
                            ...prev,
                            bank: {
                                ...prev.bank,
                                accountnumber: bankAccNum,
                                account_number: bankAccNum,
                                ifsc: bankApiData?.ifsc || bankApiData?.ifsc_code || "",
                                name: bankApiData?.name || bankApiData?.beneficiaryname || bankApiData?.beneficiary_name || "",
                                accounttype: bankApiData?.accounttype || bankApiData?.account_type || "savings",
                                bankname: bankApiData?.bankname || bankApiData?.bank_name || "",
                                branchname: bankApiData?.branchname || bankApiData?.branch_name || "",
                                isVerifiedBank: true
                            }
                        }));
                        setPrefillBankData(bankApiData);
                        setIsBankVerified(true);
                        setBankSuccess(true);
                        setBankData(true);
                        sessionStorage.setItem("bankVerified", "true");
                    }
                } catch (e) {
                    console.log("Step 3 check error:", e);
                }

                if (!step3Success) {
                    setCurrentStep(3);
                    setLoading(false);
                    return;
                }

                // If all 3 steps completed -> go to Step 4
                setCurrentStep(4);
            } catch (err) {
                console.error("KYC progress detection error:", err);
            } finally {
                setLoading(false);
            }
        };

        checkKYCProgressAndSetStep();
    }, []);

    console.log("prefillBasicData---->", formData);

    useEffect(() => {
        if (currentStep === 3) {
            const fetchBankData = async () => {
                const data = await getBankDetails();
                console.log("Bank data response from getBankDetails --->", data);
                const mobile = sessionStorage.getItem("mobile");
                if (data) {
                    const apiData = Array.isArray(data?.data) ? data.data[0] : (data?.data || data);
                    const accNum = apiData?.accountnumber || apiData?.bankaccount || apiData?.account_number || apiData?.bank_account || apiData?.account_no || "";
                    const ifscCode = apiData?.ifsc || apiData?.ifsc_code || "";
                    const holderName = apiData?.name || apiData?.beneficiaryname || apiData?.beneficiary_name || "";
                    const accType = apiData?.accounttype || apiData?.account_type || "";
                    const bName = apiData?.bankname || apiData?.bank_name || "";
                    const brName = apiData?.branchname || apiData?.branch_name || "";

                    const hasBank = Boolean(accNum);

                    if (hasBank) {
                        setFormData((prev) => ({
                            ...prev,
                            bank: {
                                ...prev.bank,
                                accountnumber: accNum,
                                account_number: accNum,
                                ifsc: ifscCode,
                                name: holderName,
                                accounttype: accType || prev.bank?.accounttype || "savings",
                                bankname: bName || prev.bank?.bankname || "",
                                branchname: brName || prev.bank?.branchname || "",
                                isVerifiedBank: Boolean(data?.is_verified !== false),
                                mobile: mobile || ""
                            }
                        }));
                        setPrefillBankData(apiData);
                        setIsBankVerified(true);
                        setBankSuccess(true);
                        setBankData(true);
                        sessionStorage.setItem("bankVerified", "true");
                    }
                }
            };
            fetchBankData();
        }
    }, [currentStep]);


    const handleBack = async () => {
        const prevStep = currentStep - 1;
        if (currentStep > 1) {
            if (prevStep === 1) {
                const data = await getAllbusinessInfo();
                if (data?.data) {
                    const apiData = data.data;
                    const companyName = apiData?.company_name || apiData?.business_name || apiData?.pan_name || "";
                    const bussinessType = apiData?.bussiness_type || apiData?.business_type || "";
                    const pincodeVal = apiData?.pincode || apiData?.area_code || "";
                    const panNo = apiData?.pan_no || apiData?.pan_number || "";
                    const gstNo = apiData?.gst_no || apiData?.gst_number || "";

                    setFormData((prev) => ({
                        ...prev,
                        business: {
                            ...prev.business,
                            gst_number: gstNo || prev.business.gst_number,
                            company_name: companyName || prev.business.company_name,
                            bussiness_type: bussinessType || prev.business.bussiness_type,
                            seller_type: apiData?.seller_type ? String(apiData.seller_type).toLowerCase() : (prev.business.seller_type || ""),
                            pan_number: panNo || prev.business.pan_number,
                            pan_name: apiData?.pan_name || companyName || prev.business.pan_name,
                            street: apiData?.street || prev.business.street,
                            city: apiData?.city || prev.business.city,
                            pincode: pincodeVal || prev.business.pincode,
                            state: apiData?.state || prev.business.state,
                            locality: apiData?.locality || prev.business.locality,
                            country: "India"
                        },
                    }));
                    setPrefillBasicData(apiData);
                    if (apiData?.gst_no || apiData?.gst_kyc) {
                        setIsGSTVerified(true);
                    }
                }
            }
            if (prevStep === 3) {
                const bankRes = await getBankDetails();
                if (bankRes) {
                    setFormData((prev) => ({
                        ...prev,
                        bank: {
                            accountnumber: bankRes?.bankaccount || "",
                            ifsc: bankRes?.ifsc || "",
                            beneficiaryname: bankRes?.beneficiaryname || "",
                            bankname: bankRes?.bankname || "",
                            branchname: bankRes?.branchname || ""
                        }
                    }));
                }
            }
            setCurrentStep(prevStep);
        }
    };

    const renderStep = () => {
        switch (currentStep) {
            case 1:
                return (
                    <BusinessDetailsStep
                        data={formData?.business || {}}
                        setData={(data) =>
                            setFormData((prev) => ({ ...prev, business: typeof data === "function" ? data(prev?.business || {}) : (data || {}) }))
                        }
                        verifyGST={verifyGST}
                        verifyPanDetails={verifyPanDetails}
                        isGSTVerified={isGSTVerified}
                        setIsGSTVerified={setIsGSTVerified}
                        isPANVerified={isPanVerified}
                        setIsPANVerified={setIsPANVerified}
                        setShowPanfield={setShowPanfield}
                        showPanField={showPanField}
                    />
                );

            case 2:
                return (
                    <BasicDetailsStep
                        data={formData?.basic || {}}
                        setData={(value) =>
                            setFormData((prev) => ({
                                ...prev,
                                basic: typeof value === "function"
                                    ? value(prev?.basic || {})
                                    : (value || {})
                            }))
                        }
                        verifyPanDetails={verifyPanDetails}
                        isPANVerified={isAadharVerified}
                        setIsPANVerified={setIsAadharVerified}
                        setPrefillBasicData={setPrefillBasicData}
                        prefillBasicData={prefillBasicData}
                        getAllbusinessInfo={getAllbusinessInfo}
                    />
                );

            case 3:
                return (
                    <BankDetailsStep
                        data={formData?.bank || {}}
                        setData={(data) =>
                            setFormData((prev) => ({
                                ...prev,
                                bank: typeof data === "function" ? data(prev?.bank || {}) : (data || {})
                            }))
                        }
                        getBankDetails={getBankDetails}
                        setPrefillBankData={setPrefillBankData}
                        bankSuccess={bankSuccess}
                        setBankData={setBankData}
                        prefillBankData={prefillBankData}
                        loading={loading}

                        setIsBankValid={setIsBankValid}
                        isBankValid={isBankValid}
                        isBankVerified={isBankVerified}
                    />
                );

            case 4:
                return (
                    <KYCVerificationStep
                        data={formData?.kyc || {}}
                        setData={(data) =>
                            setFormData((prev) => ({ ...prev, kyc: typeof data === "function" ? data(prev?.kyc || {}) : (data || {}) }))
                        }
                    />
                );
            default:
                return null;
        }
    };


    const isKYCValid =
        formData?.kyc?.terms &&
        formData?.kyc?.commission &&
        formData?.kyc?.refund;

    const activeSellerHandler = async () => {
        setLoading(true);
        try {
            const token = sessionStorage.getItem("token");
            var decoded = jwt_decode(token);
            const res = await axios({
                url: `${apiEndpoint}/snp/sellers/activate-seller`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                    "X-Custom-Authorization": `Bearer ${token}`
                },
            });
            console.log("res---->", res);
            setLoading(false);

            if (res?.data?.status === false) {
                const errMsg = res?.data?.message || "Seller activation failed.";
                toast.error(errMsg);
                setModalConfig({
                    show: true,
                    type: "error",
                    message: errMsg
                });
                return false;
            }

            const newToken = res?.data?.token || res?.data?.data?.token || res?.data?.accessToken || res?.data?.data?.accessToken || res?.data?.jwtToken;
            console.log("newToken ------>", newToken);
            if (newToken) {
                sessionStorage.setItem("token", newToken);
            }
            sessionStorage.removeItem("isSkipped");
            sessionStorage.setItem("is_activated", "true");
            sessionStorage.setItem("seller_approved", "1");

            setModalConfig({
                show: true,
                type: "success",
                message: ""
            });
            return true;
        } catch (error) {
            setLoading(false);
            console.log("Error ------>", error);
            const errMsg = error?.response?.data?.message || error?.message || "Failed to activate seller.";
            toast.error(errMsg);
            setModalConfig({
                show: true,
                type: "error",
                message: errMsg
            });
            return false;
        }
    };

    return (
        <ThemeMaker>
            <>
                {/* <ToastContainer style={{ background: "purple" }} /> */}
                {/* <Toaster bgColor="yellow" /> */}
                <SuccessModal
                    show={modalConfig.show}
                    type={modalConfig.type}
                    message={modalConfig.message}
                    onClose={() => setModalConfig({ show: false, type: "success", message: "" })}
                />
                {loading && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgba(15, 23, 42, 0.65)",
                            backdropFilter: "blur(6px)",
                            WebkitBackdropFilter: "blur(6px)",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 999999,
                            gap: "16px",
                            color: "#FFFFFF"
                        }}
                    >
                        <div
                            className="spinner-border"
                            role="status"
                            style={{ width: "3.5rem", height: "3.5rem", borderWidth: "4px", color: "#F97316" }}
                        >
                            <span className="sr-only">Loading...</span>
                        </div>
                        <h5 style={{ fontWeight: 600, fontSize: "18px", letterSpacing: "0.3px", marginTop: "10px", color: "#FFFFFF" }}>
                            Activating your seller account, please wait...
                        </h5>
                    </div>
                )}
                <div className="bg-light min-vh-100 pb-4">
                    <div className="container px-2 px-sm-3 px-md-5">
                        <ProgressBar currentStep={currentStep} />
                    </div>

                    <main className="container pb-3">
                        <div className="px-1 px-sm-2 px-md-4">

                            {renderStep()}

                            <div className="d-flex text-white py-2 rounded fw-semibold justify-content-between align-items-center flex-wrap" style={{ gap: "10px" }}>

                                <div>
                                    {currentStep > 1 ? (
                                        <button
                                            onClick={handleBack}
                                            className="px-3 px-sm-4 py-2 rounded fw-semibold"
                                            style={{ border: "1.5px solid #F75710", color: "#F75710", background: "transparent" }}
                                        >
                                            Back
                                        </button>
                                    ) : null}
                                </div>

                                <div className="d-flex align-items-center flex-wrap" style={{ gap: "10px" }}>
                                    <button
                                        onClick={() => {
                                            sessionStorage.setItem("isSkipped", true);
                                            console.log("isSkipped---->", sessionStorage.getItem("isSkipped"));
                                            history.push("/dashboard");
                                        }}
                                        className="text-white px-3 px-sm-4 py-2 rounded fw-semibold d-flex gap-2 align-items-center"
                                        style={{
                                            background: "linear-gradient(90deg, #F75710, #FC8809)",
                                            border: "none",
                                            gap: "5px",
                                        }}
                                    >
                                        Skip KYC <BsSkipForwardFill />
                                    </button>

                                    <button
                                        onClick={() => {
                                            handleNext();
                                        }}
                                        disabled={
                                            loading ||
                                            (currentStep === TOTAL_STEPS && !isKYCValid)
                                        }
                                        className="text-white px-4 py-2 rounded fw-semibold"
                                        style={{
                                            background: "linear-gradient(90deg, #F75710, #FC8809)",
                                            border: "none",
                                            opacity: (currentStep === TOTAL_STEPS && !isKYCValid) ? 0.6 : 1
                                        }}
                                    >
                                        {loading
                                            ? "Processing..."
                                            : currentStep === TOTAL_STEPS
                                                ? "Submit"
                                                : "Next"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </>
        </ThemeMaker>
    );
}

